import { useState, createContext, useContext, useEffect } from 'react';
import Command from 'app/protocol/Command';
import { useSipWebsocket } from './SipWebsocketProvider';
import QueryDeviceRegistryCommand from './deviceRegistry/QueryDeviceRegistryCommand';
import Recipient from './Recipient';

export const DeviceRegistryContext = createContext(null);

export const useDeviceRegistry = () => {
	return useContext(DeviceRegistryContext);
};

export default function DeviceRegistryProvider(props) {
	const { initialized, sipId, message, sendMessage } = useSipWebsocket();
	const [deviceRegistryInitialized, setDeviceRegistryInitialized] = useState(false);
	const [deviceList, setDeviceList] = useState([]);

	useEffect(() => {
		if (initialized) {
			sendMessage(new QueryDeviceRegistryCommand(sipId, Recipient.BACKEND));
		}
	}, [initialized]);

	useEffect(() => {
		if (message instanceof Command) {
			if (message.command === Command.PUBLISH_DEVICE_REGISTRY) {
				setDeviceRegistryInitialized(true);
				setDeviceList(message.externalIdList);
			} else if (message.command === Command.DEVICE_REGISTERED) {
				if (deviceList.indexOf(message.externalId) === -1) setDeviceList([...deviceList, message.externalId]);
			} else if (message.command === Command.DEVICE_UNREGISTERED) {
				if (deviceList.indexOf(message.externalId) > -1) setDeviceList(deviceList.filter(d => d !== message.externalId));
			}
		}
	}, [message]);

	const value = {
		deviceRegistryInitialized,
		deviceList
	};

	return <DeviceRegistryContext.Provider value={value}>{props.children}</DeviceRegistryContext.Provider>;
}
